<div class="smooth-scrolling">

    <!-- product banner section Start  -->
    <section class="product-banner" *ngIf="selectedCategory && selectedCategory.length == 1">
        <div class="row">
            <div class="col-12">
                <div class="product-detail">
                    <div class="product-img">
                        <img appPreLoading [lazyLoad]="categoryDetails && categoryDetails?.imageList && categoryDetails?.imageList.length > 0 && categoryDetails?.imageList[0]?.path ?? categoryDetails?.imageList[0]?.path" alt="image">
                    </div>
                    <div class="product-detail-text">
                        <h5>{{categoryDetails?.name}}</h5>
                        <span [innerHTML]="categoryDetails?.description"></span>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- product banner section End -->

     <!-- Top-categories section start  -->

     <section class="top-categories" *ngIf="selectedCategory && selectedCategory.length == 1">
      <div class="row">
          <div class="col-12">
              <div class="top-header">
                  <h5>Top categories</h5>
              </div>
              <div class="top-categories-scllor scrollbar">
                <div class="categories-slider arrow-bg-remove" *ngIf="mGetAllShopAllModuleDataResponse && mGetAllShopAllModuleDataResponse.data && mGetAllShopAllModuleDataResponse.data.subCategoryList && mGetAllShopAllModuleDataResponse.data.subCategoryList.length > 0">
                  <div *ngFor="let subCategory of mGetAllShopAllModuleDataResponse.data.subCategoryList, let i = index">
                    <div class="top-categories-detail" >
                      <a  (click)="selectSubCategory(subCategory.id, true)">
                        <div class="top-categories-detail-img" [ngStyle]="{'border': selectedSubCategory.includes(''+subCategory.id) ? '2px solid green' : '2px solid transparent'}">
                          <img  [src]="subCategory && subCategory.imageList && subCategory.imageList.length > 0 && subCategory.imageList[0].path && subCategory.imageList[0].path" (error)="handleImageError($event)" />
                        </div>
                        <div class="top-categories-detail-text">
                            <h5><a>{{subCategory.name}}</a></h5>
                        </div>
                      </a>
                     </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
  </section>

  <!-- Top-categories section End  -->
  <!-- all product section Start  -->

  <section class="all-product">
      <div class="row">
        <div class="all-product-heading mt-0">
          <h5>All Products</h5>
        </div>
        <div class="col-3"></div>
        <div class="col-lg-9 product-count">Showing {{mGetProductResponse?.totalRecords}} item(s)</div>
      </div>
      <div class="row sticky-product"> 
        <i *ngIf="mGetProductResponse && mGetProductResponse.data && mGetProductResponse.data.length < 1 && isLoading" class="no-record-text" [ngClass]="{'fa me-1 fa-spin fa-spinner': isLoading, '': !isLoading}"></i>
        <div class="col-3 d-lg-flex sticky-left-product">
              <div class="accordion scrollbar" id="accordionExample">
                  <div class="accordion-item">
                      <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                          Sort by {{selectedSortBy}}
                        </button>
                      </h2>
                      <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <ul class="p-0 sort-new-redio">
                            <li class="category-checkbox radio-check-cat">
                              <input id="popularity3" type="radio" name="sort2"
                                (click)="selectRelevance(true)"
                                [checked]="relevence">
                              <label for="popularity3" class="lbl">Popularity</label>
                            </li>
                            <li class="category-checkbox radio-check-cat" >
                              <input id="pricelh3" type="radio" name="sort2"
                                 (click)="selectLowToHigh(false,true)"
                                 [checked]="priceHighToLow == false">
                              <label for="pricelh3" class="lbl">Price: Low to High</label>
                            </li>
                            <li class="category-checkbox radio-check-cat">
                              <input id="pricehl3" type="radio" name="sort2"
                                (click)="selectHighToLow(true,true)"
                                [checked]="priceHighToLow == true">
                              <label for="pricehl3" class="lbl">Price: High to Low</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button *ngIf="selectIndex <= 0" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          Brand 
                      </button>
                      <button *ngIf="selectIndex > 0" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Brand ({{selectIndex}})
                    </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <ul *ngIf="mGetBrandResponse && mGetBrandResponse.data && mGetBrandResponse.data.length > 0" class="p-0">
                            <li class="category-checkbox" *ngFor="let brand of mGetBrandResponse.data ; let i = index">
                              <input id="brand_{{brand.id}}" type="checkbox" name="brand"
                                [checked]="selectedBrandList && selectedBrandList.length && selectedBrandList.includes(''+brand.id)"
                                (click)="selectBrand(brand.id,true)">
                              <label for="brand_{{brand.id}}" class="lbl">{{brand.name}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  <div class="accordion-item" *ngIf="priceLists && priceLists.length > 0">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                          Price
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        <ul class="p-0">
                          <li class="category-checkbox" *ngFor="let price of priceLists; let i = index">
                              <input id="priceList_{{i+1}}" type="checkbox" name="price"
                              [checked]="selectedPrice && selectedPrice.length && selectedPrice.includes(''+(price))"
                              (click)="selectPrice(price,true)">
                            <label for="priceList_{{i+1}}" class="lbl">{{price}}</label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item" *ngIf="genderList && genderList.length > 0">
                      <h2 class="accordion-header" id="headingFor">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFor" aria-expanded="false" aria-controls="collapseFor">
                          Gender
                        </button>
                      </h2>
                      <div id="collapseFor" class="accordion-collapse collapse" aria-labelledby="headingFor" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <ul class="p-0">
                            <li class="category-checkbox" *ngFor="let genders of genderList; let i = index">
                              <input id="gender_{{genders.id}}" type="checkbox" name="genders"
                                [checked]="gender == genders.id"
                                (click)="selectGender(genders.id,true)">
                              <label for="gender_{{genders.id}}" class="lbl">{{genders.message}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item" *ngIf="mGetAllShopAllModuleDataResponse && mGetAllShopAllModuleDataResponse.data && mGetAllShopAllModuleDataResponse.data.skinTypeList && mGetAllShopAllModuleDataResponse.data.skinTypeList.length > 0">
                      <h2 class="accordion-header" id="headingFive">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                          Skin type
                        </button>
                      </h2>
                      <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <ul class="p-0">
                            <li class="category-checkbox"
                              *ngFor="let skinType of mGetAllShopAllModuleDataResponse.data.skinTypeList, let i = index">
                              <input id="skinType_{{skinType.id}}" type="checkbox" name="skinType"
                                (click)="selectSkinType(skinType.id, true)"
                                [checked]="skinTypeArray && skinTypeArray.length && skinTypeArray.includes(''+skinType.id)">
                              <label for="skinType_{{skinType.id}}">{{skinType.name}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item" *ngIf="mGetAllShopAllModuleDataResponse && mGetAllShopAllModuleDataResponse.data && mGetAllShopAllModuleDataResponse.data.skinConcernList && mGetAllShopAllModuleDataResponse.data.skinConcernList.length > 0">
                      <h2 class="accordion-header" id="headingSix">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                          Concern
                        </button>
                      </h2>
                      <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <ul class="p-0">
                            <li class="category-checkbox"
                              *ngFor="let skinConcern of mGetAllShopAllModuleDataResponse.data.skinConcernList, let i = index">
                              <input id="skinConcern_{{skinConcern.id}}" type="checkbox" name="skinConcern"
                                (click)="selectSkinConcern(skinConcern.id, true)"
                                [checked]="skinConcernArray && skinConcernArray.length && skinConcernArray.includes(''+skinConcern.id)">
                              <label for="skinConcern_{{skinConcern.id}}" class="lbl">{{skinConcern.name}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item" *ngIf="mCategoryResponseModal && mCategoryResponseModal.data && mCategoryResponseModal.data.length > 0">
                      <h2 class="accordion-header" id="headingSeven">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                          Category
                        </button>
                      </h2>
                      <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <ul class="p-0">
                            <li class="category-checkbox"
                              *ngFor="let category of mCategoryResponseModal.data;let i = index">
                              <input id="category_{{category.id}}" type="checkbox" name="category"
                                (click)="selectCategory(category.id,true)"
                                [checked]="selectedCategory && selectedCategory.length > 0 && selectedCategory.includes(''+category.id)">
                              <label for="category_{{category.id}}" class="lbl">{{category.name}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item" *ngIf="mGetAllShopAllModuleDataResponse && mGetAllShopAllModuleDataResponse.data && mGetAllShopAllModuleDataResponse.data.subCategoryList && mGetAllShopAllModuleDataResponse.data.subCategoryList.length > 0">
                      <h2 class="accordion-header" id="headingSix">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSe" aria-expanded="false" aria-controls="collapseSe">
                          Sub Category
                        </button>
                      </h2>
                      <div id="collapseSe" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <ul class="p-0">
                            <li class="category-checkbox"
                              *ngFor="let subCategory of mGetAllShopAllModuleDataResponse.data.subCategoryList;let i = index">
                              <input id="subCategory_mob_{{subCategory.id}}" type="checkbox" name="subCategory"
                                (click)="selectSubCategory(subCategory.id,true)"
                                [checked]="selectedSubCategory && selectedSubCategory.length && selectedSubCategory.includes(''+subCategory.id)">
                              <label for="subCategory_mob_{{subCategory.id}}" class="lbl">{{subCategory.name}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item" *ngIf="leafLevelCategoryList && leafLevelCategoryList.length > 0">
                      <h2 class="accordion-header" id="headingSevenLeafCategory">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#headingSevenLeaf" aria-expanded="false" aria-controls="collapseSe">
                          Leaf Level Category
                        </button>
                      </h2>
                      <div id="headingSevenLeaf" class="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <ul class="p-0">
                            <li class="category-checkbox"
                              *ngFor="let leafLevelCategory of leafLevelCategoryList;let i = index">
                              <input id="leafLevelCategory_{{leafLevelCategory.id}}" type="checkbox" name="leafLevelCategory"
                                (click)="selectLeafLevelCategory(leafLevelCategory.id,true)"
                                [checked]="selectedLeafLevelCategory && selectedLeafLevelCategory.length && selectedLeafLevelCategory.includes(''+leafLevelCategory.id)">
                              <label for="leafLevelCategory_{{leafLevelCategory.id}}" class="lbl">{{leafLevelCategory.title}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                </div>
          </div> 
          <div class="col-lg-9 col-md-12 sticky-right-product" *ngIf="mGetProductResponse && mGetProductResponse.data && mGetProductResponse.data.length > 0">
              <div class="row">
                  <div class="col-lg-4 col-md-4 col-6 mb-3 p-0  product-crad-p" *ngFor="let product of mGetProductResponse.data; let i  = index">
                      <app-product-box [color]="product.category && product.category.color ? product.category.color : ''"  [product]="product" [mAddUpdateCartModule]="mAddUpdateCartModule" [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse" [mWishlistData]="mWishlistData"></app-product-box>
                  </div>
                  <div class="col-lg-12 d-lg-flex justify-content-center" *ngIf="pageList && pageList.length > 0">
                      <div class="page-navigation">
                        <nav aria-label="Page navigation example">
                          <ul class="pagination">
                            <li class="page-item bg-white-border" [ngClass]="selectedPage == 1 ? 'no-pointer-event' : ''" (click)="selectPage(selectedPage - 1)"><a class="page-link"><i class="fa-solid fa-chevron-left" style="color: #000;"></i></a></li>
                            <li class="page-item" *ngIf="selectedPage >= 2 && totalPages > 4" (click)="selectPage(pageList[0] - 1)"><a>...</a></li>
                            <li class="page-item" [ngClass]="selectedPage == page ? 'active' : ''" *ngFor="let page of pageList;" (click)="selectPage(page)"><a class="page-link">{{page}}</a></li>
                            <li class="page-item" *ngIf="selectedPage <= totalPages - 4" (click)="selectPage(pageList[pageList.length - 1] + 1)"><a >...</a></li>
                            <li class="page-item bg-white-border" [ngClass]="selectedPage == totalPages ? 'no-pointer-event' : ''" (click)="selectPage(selectedPage + 1)"><a class="page-link" ><i class="fa-solid fa-chevron-right" style="color: #000;"></i></a></li>
                          </ul>
                        </nav>
                        <div class="one-to-page">
                          <span>Page {{selectedPage}} of {{totalPages}}</span>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
          <div *ngIf="mGetProductResponse && mGetProductResponse.data && mGetProductResponse.data.length < 1 && !isLoading" class="col-lg-9 col-md-12 no-record-text" >
            <span>No Record Found!</span>
          </div>
      </div>
  </section>
  <!-- all product section End  -->
  <!-- fillter section Start  -->
  <section class="fillter d-lg-none d-block">
    <div class="fillter-btn">
      <button class="btn btn-primary btn-sort" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom">
        <span><img src="assets/images/Settings-adjust.svg" alt="icon"></span>
        Sort
      </button>
      <button class="btn btn-primary btn-sort" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
        <span><img src="/assets/images/Filter.svg" alt="icon"></span>
        Filter {{selectedFilter > 0 ? '('+selectedFilter+')':''}}</button>


      <div class="fillter-section">
        <div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasBottom" aria-labelledby="offcanvasBottomLabel">
          <div class="offcanvas-header">
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div class="offcanvas-body small">
            <ul class="p-0 sort-new-redio">
              <li class="category-checkbox category-checkbox-m radio-check-cat">
                <input id="popularity1" type="radio" name="sort1"
                  (click)="selectRelevance(true)"
                  [checked]="relevence">
                <label for="popularity1" class="lbl">Popularity</label>
              </li>
              <li class="category-checkbox category-checkbox-m radio-check-cat" >
                <input id="pricelh1" type="radio" name="sort1"
                   (click)="selectLowToHigh(false,true)"
                   [checked]="priceHighToLow == false">
                <label for="pricelh1" class="lbl">Price: Low to High</label>
              </li>
              <li class="category-checkbox category-checkbox-m radio-check-cat">
                <input id="pricehl1" type="radio" name="sort1"
                  (click)="selectHighToLow(true,true)"
                  [checked]="priceHighToLow == true">
                <label for="pricehl1" class="lbl">Price: High to Low</label>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </section>

  <div class="sortby-filter">
    <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
      <div class="offcanvas-header">
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <div class="dropdown mt-3">

          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                  Sort by {{selectedSortBy}}
                </button>
              </h2>
              <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  <ul class="p-0 sort-new-redio">
                    <li class="category-checkbox radio-check-cat">
                      <input id="popularity" type="radio" name="sort"
                        (click)="selectRelevance()"
                        [checked]="relevence">
                      <label for="popularity" class="lbl">Popularity</label>
                    </li>
                    <li class="category-checkbox radio-check-cat" >
                      <input id="pricelh" type="radio" name="sort"
                         (click)="selectLowToHigh(false)"
                         [checked]="priceHighToLow == false">
                      <label for="pricelh" class="lbl">Price: Low to High</label>
                    </li>
                    <li class="category-checkbox radio-check-cat">
                      <input id="pricehl" type="radio" name="sort"
                        (click)="selectHighToLow(true)"
                        [checked]="priceHighToLow == true">
                      <label for="pricehl" class="lbl">Price: High to Low</label>
                    </li>
                  </ul>
              </div>
              </div>
            </div>
            <div class="accordion-item" *ngIf="mGetBrandResponse && mGetBrandResponse.data && mGetBrandResponse.data.length > 0">
              <h2 class="accordion-header" id="flush-headingTwo">
                <button *ngIf="selectIndex <= 0" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                  Brand
                </button>
                <button *ngIf="selectIndex > 0" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                  Brand ({{selectIndex}})
                </button>
              </h2>
              <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
                (scrolled)="onScroll()">
                  <ul  class="p-0" >
                    <li class="category-checkbox" *ngFor="let brand of mGetBrandResponse.data ; let i = index">
                      <input id="brand_mob_{{brand.id}}" type="checkbox" name="brand"
                        [checked]="selectedBrandList && selectedBrandList.length && selectedBrandList.includes(''+brand.id)"
                        (click)="selectBrand(brand.id)">
                      <label for="brand_mob_{{brand.id}}" class="lbl">{{brand.name}}</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="accordion-item" *ngIf="priceLists && priceLists.length > 0">
              <h2 class="accordion-header" id="flush-headingThree">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                  Price
                </button>
              </h2>
              <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  <ul class="p-0">
                    <li class="category-checkbox" *ngFor="let price of priceLists; let i = index">
                        <input id="priceList_mobile_{{i+1}}" type="checkbox" name="price"
                        [checked]="selectedPrice && selectedPrice.length && selectedPrice.includes(''+(price))"
                        (click)="selectPrice(price)">
                      <label for="priceList_mobile_{{i+1}}" class="lbl">{{price}}</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="accordion-item" *ngIf="genderList && genderList.length > 0">
              <h2 class="accordion-header" id="flush-headingFor">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFor" aria-expanded="false" aria-controls="flush-collapseThree">
                  Gender
                </button>
              </h2>
              <div id="flush-collapseFor" class="accordion-collapse collapse" aria-labelledby="flush-headingFor" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  <ul class="p-0">
                    <li class="category-checkbox" *ngFor="let genders of genderList; let i = index">
                      <input id="genders_{{genders.id}}" type="checkbox" name="genders"
                        [checked]="gender == genders.id"
                        (click)="selectGender(genders.id)">
                      <label for="genders_{{genders.id}}" class="lbl">{{genders.message}}</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="accordion-item" *ngIf="mGetAllShopAllModuleDataResponse && mGetAllShopAllModuleDataResponse.data && mGetAllShopAllModuleDataResponse.data.skinTypeList && mGetAllShopAllModuleDataResponse.data.skinTypeList.length > 0">
              <h2 class="accordion-header" id="flush-headingFive">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                  Skin type
                </button>
              </h2>
              <div id="flush-collapseFive" class="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  <ul class="p-0">
                    <li class="category-checkbox"
                      *ngFor="let skinType of mGetAllShopAllModuleDataResponse.data.skinTypeList, let i = index">
                      <input id="skinType_mob_{{skinType.id}}" type="checkbox" name="skinType"
                        [checked]="skinTypeArray && skinTypeArray.length && skinTypeArray.includes(''+skinType.id)"
                        (click)="selectSkinType(skinType.id)">
                      <label for="skinType_mob_{{skinType.id}}">{{skinType.name}}</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="accordion-item" *ngIf="mGetAllShopAllModuleDataResponse && mGetAllShopAllModuleDataResponse.data && mGetAllShopAllModuleDataResponse.data.skinConcernList && mGetAllShopAllModuleDataResponse.data.skinConcernList.length > 0">
              <h2 class="accordion-header" id="flush-headingSix">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                  Skin Concern
                </button>
              </h2>
              <div id="flush-collapseSix" class="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  <ul class="p-0">
                    <li class="category-checkbox"
                      *ngFor="let skinConcern of mGetAllShopAllModuleDataResponse.data.skinConcernList, let i = index">
                      <input id="skinConcern_mob_{{skinConcern.id}}" type="checkbox" name="skinConcern"
                        (click)="selectSkinConcern(skinConcern.id)"
                        [checked]="skinConcernArray && skinConcernArray.length && skinConcernArray.includes(''+skinConcern.id)">
                      <label for="skinConcern_mob_{{skinConcern.id}}" class="lbl">{{skinConcern.name}}</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="accordion-item" *ngIf="mCategoryResponseModal && mCategoryResponseModal.data && mCategoryResponseModal.data.length > 0">
              <h2 class="accordion-header" id="flush-headingSe">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSe" aria-expanded="false" aria-controls="flush-collapseSeven">
                  Category
                </button>
              </h2>
              <div id="flush-collapseSe" class="accordion-collapse collapse" aria-labelledby="flush-headingSe" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  <ul class="p-0">
                    <li class="category-checkbox"
                      *ngFor="let category of mCategoryResponseModal.data;let i = index">
                      <input id="category_mob_{{category.id}}" type="checkbox" name="category"
                        (click)="selectCategory(category.id)"
                        [checked]="selectedCategory && selectedCategory.length > 0 && selectedCategory.includes(''+category.id)">
                      <label for="category_mob_{{category.id}}" class="lbl">{{category.name}}</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="accordion-item"  *ngIf="mGetAllShopAllModuleDataResponse && mGetAllShopAllModuleDataResponse.data && mGetAllShopAllModuleDataResponse.data.subCategoryList && mGetAllShopAllModuleDataResponse.data.subCategoryList.length > 0">
              <h2 class="accordion-header" id="subCategory">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#subCategory-collapseSe" aria-expanded="false" aria-controls="flush-collapseSeven">
                  Sub Category
                </button>
              </h2>
              <div id="subCategory-collapseSe" class="accordion-collapse collapse" aria-labelledby="subCategory" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  <ul class="p-0">
                    <li class="category-checkbox"
                    *ngFor="let subCategory of mGetAllShopAllModuleDataResponse.data.subCategoryList;let i = index">
                    <input id="skinConcern_mob_{{subCategory.id}}" type="checkbox" name="subCategory"
                      (click)="selectSubCategory(subCategory.id)"
                      [checked]="selectedSubCategory && selectedSubCategory.length && selectedSubCategory.includes(''+subCategory.id)">
                    <label for="skinConcern_mob_{{subCategory.id}}" class="lbl">{{subCategory.name}}</label>
                  </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="accordion-item"  *ngIf="leafLevelCategoryList && leafLevelCategoryList.length > 0">
              <h2 class="accordion-header" id="leafLevelCategory">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#leafLevelCategory-collapseSe" aria-expanded="false" aria-controls="flush-collapseSeven">
                  Leaf level Category
                </button>
              </h2>
              <div id="leafLevelCategory-collapseSe" class="accordion-collapse collapse" aria-labelledby="leafLevelCategory" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  <ul class="p-0">
                    <li class="category-checkbox"
                    *ngFor="let leafLevelCategory of leafLevelCategoryList;let i = index">
                    <input id="leafLevelCategory_mob_{{leafLevelCategory.id}}" type="checkbox" name="leafLevelCategory"
                      (click)="selectLeafLevelCategory(leafLevelCategory.id)"
                      [checked]="selectedLeafLevelCategory && selectedLeafLevelCategory.length && selectedLeafLevelCategory.includes(''+leafLevelCategory.id)">
                    <label for="leafLevelCategory_mob_{{leafLevelCategory.id}}" class="lbl">{{leafLevelCategory.title}}</label>
                  </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-p filter-under-btn d-lg-none d-flex">
          <div class="button-filler apply-btn">
            <a class="btn btn-primary" role="button" aria-controls="offcanvasExample" data-bs-dismiss="offcanvas"
              (click)="clearFilter()">
              Cancel
            </a>
          </div>
          <div class="button-filler apply-btn bg-apply">
            <a class="btn btn-primary" role="button" aria-controls="offcanvasExample" data-bs-dismiss="offcanvas"
              (click)="appyFilter()">
              APPLY
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer-bg [appClass]="appClass"></app-footer-bg>